import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {ToastController} from "@ionic/angular";
import { TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class GestionErreursService {

  constructor(
    private toastController: ToastController,
    private translateService: TranslateService
  ) { }

  handleError(err: any) {
    console.error(err);
    // status 0 : pas de reponse exploitable (hors ligne, serveur injoignable, ou requete refusee par nginx sans en-tetes CORS)
    if(err?.status === 0) {
      this.presentToast('bottom', this.translateService.instant('error.connexionImpossible'));
    } else if(err?.status === 413) {
      this.presentToast('bottom', this.translateService.instant('error.fichierTropVolumineux'));
    } else if(err?.error?.code === 'LIMITE_MEMBRES_ATTEINTE' && Capacitor.isNativePlatform()) {
      // Pas de mention d'abonnement / paiement dans les apps mobiles (regles App Store et Play Store)
      this.presentToast('bottom', this.translateService.instant('error.limiteMembresMobile'));
    } else if(err?.error?.message) {
      this.presentToast('bottom', err?.error?.message);
    } else if(err?.message) {
      this.presentToast('bottom', err.message);
    } else {
      this.presentToast('bottom', '');
    }
  }

  async presentToast(position: 'top' | 'middle' | 'bottom', message: string) {
    if(!message || message === null || message === undefined || message === '') {
      message = this.translateService.instant('error.errorHappening');
    }
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: position,
      cssClass: 'err-toast'
    });

    await toast.present();
  }
}
